import { createRedirectListener } from 'www/utils'
import initTooltips from 'www/doctors.blocks/common/tippy-tooltip/tippy-tooltip'

const BLOCK_NAME = 'b-profile-card'
const CLASS_NAMES = {
  img: `${BLOCK_NAME}__img`,
}

createRedirectListener({
  className: CLASS_NAMES.img,
})

initTooltips()
document.addEventListener('content-replace', () => initTooltips(), false)
